import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import MonotoneChain from './MonotoneChain';
import ArrayList from '../../../../../java/util/ArrayList';
import Quadrant from '../../geomgraph/Quadrant';
var MonotoneChainBuilder = /*#__PURE__*/function () {
  function MonotoneChainBuilder() {
    _classCallCheck(this, MonotoneChainBuilder);
  }
  _createClass(MonotoneChainBuilder, null, [{
    key: "findChainEnd",
    value: function findChainEnd(pts, start) {
      var safeStart = start;
      while (safeStart < pts.length - 1 && pts[safeStart].equals2D(pts[safeStart + 1])) safeStart++;
      if (safeStart >= pts.length - 1) return pts.length - 1;
      var chainQuad = Quadrant.quadrant(pts[safeStart], pts[safeStart + 1]);
      var last = start + 1;
      while (last < pts.length) {
        if (!pts[last - 1].equals2D(pts[last])) {
          var quad = Quadrant.quadrant(pts[last - 1], pts[last]);
          if (quad !== chainQuad) break;
        }
        last++;
      }
      return last - 1;
    }
  }, {
    key: "getChains",
    value: function getChains() {
      if (arguments.length === 1) {
        var pts = arguments[0];
        return MonotoneChainBuilder.getChains(pts, null);
      } else if (arguments.length === 2) {
        var _pts = arguments[0],
          context = arguments[1];
        var mcList = new ArrayList();
        var chainStart = 0;
        do {
          var chainEnd = MonotoneChainBuilder.findChainEnd(_pts, chainStart);
          var mc = new MonotoneChain(_pts, chainStart, chainEnd, context);
          mcList.add(mc);
          chainStart = chainEnd;
        } while (chainStart < _pts.length - 1);
        return mcList;
      }
    }
  }]);
  return MonotoneChainBuilder;
}();
export { MonotoneChainBuilder as default };